module.exports = __webpack_public_path__ + "static/media/slide-6.dd0ff2e6.webp";